import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { SliderStyles, applySliderCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-value-slider',
  standalone: true,
  host: {
    '[class]': 'styleClassName()',
  },
})
export class FlxSliderStyleDirective {
  componentStyle = input<{
    style: SliderStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applySliderCustomStyles(this.componentStyle().style, theme(), fonts())
      this.styleClassName.set(className)
    })
  }
}
